var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestServiceBase } from '@ane/core/lib/services/RestServiceBase';
import { WPSProxyConverter } from '@ane/core/lib/services/WPSProxy';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
const getErrorMessage = (result) => {
    var _a;
    if (200 !== result.statusCode) {
        return (_a = result.errorContext) === null || _a === void 0 ? void 0 : _a.displayError;
    }
    else {
        return '';
    }
};
const apiVersion = '2024-04-01-preview';
let ComputeResource = class ComputeResource extends RestServiceBase {
    constructor() {
        /**
         * getURL in API methods to ensure the TAS request has completed
         */
        super(EnvironmentService.endpoints.cms);
    }
    putCompute(workspaceId, postParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = `/workspaces/${workspaceId}/compute-resources/${postParams.id}?api-version=${apiVersion}`;
            const result = yield this._put(postParams, address);
            result.error = getErrorMessage(result);
            return result;
        });
    }
    getCompute(workspaceId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = `/workspaces/${workspaceId}/compute-resources/${id}?api-version=${apiVersion}`;
            const result = yield this._get(address);
            result.error = getErrorMessage(result);
            return result;
        });
    }
    getComputeList(workspaceId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const filter = id ? `&$filter=CONTAINS(id,${id})` : '';
            const address = `/workspaces/${workspaceId}/compute-resources?api-version=${apiVersion}${filter}`;
            const result = yield this._get(address);
            result.error = getErrorMessage(result);
            return result;
        });
    }
    deleteCompute(workspaceId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = `/workspaces/${workspaceId}/compute-resources/${id}?api-version=${apiVersion}`;
            const result = yield this._delete(address);
            result.error = getErrorMessage(result);
            return result;
        });
    }
};
ComputeResource = __decorate([
    WPSProxyConverter()
], ComputeResource);
export default new ComputeResource();

//# sourceMappingURL=UnifiedCompute.resource.js.map
